import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ObjectUtils } from "src/app/utils/ObjectUtils";
import { environment } from "src/environments/environment";
import { BillDTO } from "../../schema/Billing/Bills/BillDTO";
import { CreateBillRequest } from "../../schema/Billing/Bills/CreateBillRequestDTO";
import { BillQueryParameterDTO } from "../../schema/Billing/Filter/BillQueryParameterDTO";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";

@Injectable({
    providedIn: "root"
})
export class ApiBillingBillsService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/Bill`;
    }

    public list(parameters: BillQueryParameterDTO): Observable<GetDataDTO<BillDTO>> {
        const httpParams = new HttpParams({
            fromObject: ObjectUtils.removeNullUndefinedFields(parameters) as any
        });

        return this.http.get<GetDataDTO<BillDTO>>(`${this.relativePath}`, {
            params: httpParams
        });
    }

    public create(to: CreateBillRequest): Observable<BillDTO> {
        return this.http.post<BillDTO>(`${this.relativePath}`, to);
    }

    public get(id: string): Observable<BillDTO> {
        return this.http.get<BillDTO>(`${this.relativePath}/${id}`);
    }

    public cancel(id: string, reason: string): Observable<BillDTO> {
        return this.http.delete<BillDTO>(`${this.relativePath}/${id}`, {
            params: { reason: reason }
        });
    }

    public hasBillForCourse(courseId: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.relativePath}/hasBillForCourse/${courseId}`);
    }

    public hasBillForCertificate(courseId: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.relativePath}/hasBillForCertificate/${courseId}`);
    }

    public hasBillForPlans(planIds: string[]): Observable<boolean> {
        const httpParams = new HttpParams({
            fromObject: { planIds: planIds.join(",") }
        });

        return this.http.get<boolean>(`${this.relativePath}/hasBillForPlans`, {
            params: httpParams
        });
    }
}
